import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";


/**
 * Creates a download tracking record for laboratory assets
 * @param {Array} assetIds - Array of asset IDs that were downloaded
 * @param {string} userId - User ID who performed the download
 * @returns {Promise} - API response
 */
export async function store(assetIds, userId = null) {
  const axios = axiosInstance().primoLab;

  const downloadData = {
    asset_ids: assetIds,
    user_id: userId
  };

  try {
    const response = await axios.post("/downloads", downloadData);
    return response.data;
  } catch (error) {
    console.error('Error creating download record:', error);
    throw error;
  }
}
